import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesVisitOut {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    // console.log("门店信息");
    if(webcontext.ConfigType.toLowerCase()=="form"){
      let request = JSON.parse(webcontext.RequestBody);
      webcontext.OpType = "Edite";
      if(request.DeviationNumber){//下班门店坐标
        request.a_OnDeviationNumber = request.DeviationNumber;//上班与门店的偏差值
        delete request.DeviationNumber;
      }
     let datepie:DatePipe =new DatePipe("en-US");
      request.a_EndDate = datepie.transform(new Date(),"yyyy-MM-dd HH:mm:ss");
      // request.a_FK_TBVisitState_ID = "2DD94392-6FD7-4D2B-B9C5-0FF1B7F733C1";//拜访成功
      if(request.goonnumber){//进店与离店误差值
        request.a_GoOnDeviationNumber = request.goonnumber;//上班与门店的偏差值
        delete request.goonnumber;
      }
      // if(typeof(request.a_EndAddress)=="undefined" && (typeof(request.a_EndRemark)=="undefined" || request.a_EndRemark.toString().trim()=="")){
      //     webcontext.ResponseMessage.ErrorMessage = "请填写备注";
      //      webcontext.ResponseMessage.Success = false;
      // }
      // else
      if(typeof(request.a_EndPhoto)=="undefined"){
        webcontext.ResponseMessage.ErrorMessage="必须拍摄门头照";
        webcontext.ResponseMessage.Success =false;
      }else if(request.a_EndPhoto.toString().trim() == ""){
        webcontext.ResponseMessage.ErrorMessage="必须拍摄门头照";
        webcontext.ResponseMessage.Success =false;
      }
      webcontext.SpecialParameter = "leavehome";//进店
      // if(request.a_EndAddress){//定位地址
      //    let getRow=webcontext.ID.split('&');
      //     request["a_ID"]= getRow[0];
      // }
      let getRow=webcontext.ID.split('&');
              request["a_ID"]= getRow[0];
  //  consle.log(t);
  // let repone ={"a_AuditStatus":"0","CHILDOBJ_TypeOfLeaveSysUserXML":{"Datas":[{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"},{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"}],"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"}},"a_StartDate":"2019-03-11 23:59:59","a_EndDate":"2019-03-13 23:59:59","a_LeaveLength":"10","a_Remarks":"sadfasdasdasd"};
      webcontext.RequestBody = JSON.stringify(request);
    }

    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
    const that = this;
    if (webParameterContext.ConfigType.toLowerCase() == "form") {
      if (webContext.ResponseMessage.Success) {
        let datepie: DatePipe = new DatePipe("en-US");
        if (webContext.Other) {
          webContext.Other.Success = true;
          webContext.url = "/tabs/contact/TodayVisitPlan/type/" + new Date().getTime();
        } else {
          webContext.Other = { "Success": true, "url": "/tabs/contact/TodayVisitPlan/type/" + new Date().getTime() };
        }
      }
    }
    return webContext
  }
  

}